import { useQuery } from "@tanstack/react-query";
import {
  getMerchantsDetail,
  getMerchantsPublicIDDetail,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MERCHANT_QUERY_KEY = "MERCHANT_DETAIL";

export const merchantKeys = {
  all: [MERCHANT_QUERY_KEY],
  byMerchantPublicId: (merchantPublicID?: string) => [
    ...merchantKeys.all,
    merchantPublicID,
  ],
};

export const useGetMerchantQuery = (publicID?: string, enabled = true) =>
  useQuery({
    queryKey: merchantKeys.byMerchantPublicId(publicID),
    queryFn: processResponseWithApiProblemDetails(() =>
      publicID ? getMerchantsPublicIDDetail(publicID) : getMerchantsDetail(),
    ),
    enabled,
  });
